import React from 'react';

export function ChartIcon() {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.8334 18.3335H2.16675C1.82508 18.3335 1.54175 18.0502 1.54175 17.7085C1.54175 17.3668 1.82508 17.0835 2.16675 17.0835H18.8334C19.1751 17.0835 19.4584 17.3668 19.4584 17.7085C19.4584 18.0502 19.1751 18.3335 18.8334 18.3335Z"
        fill="#12B76A"
      />
      <path
        d="M8.625 3.33317V18.3332H12.375V3.33317C12.375 2.4165 12 1.6665 10.875 1.6665H10.125C9 1.6665 8.625 2.4165 8.625 3.33317Z"
        fill="#12B76A"
      />
      <path
        opacity="0.4"
        d="M3 8.33317V18.3332H6.33333V8.33317C6.33333 7.4165 6 6.6665 5 6.6665H4.33333C3.33333 6.6665 3 7.4165 3 8.33317Z"
        fill="#12B76A"
      />
      <path
        opacity="0.4"
        d="M14.6667 12.5002V18.3335H18.0001V12.5002C18.0001 11.5835 17.6667 10.8335 16.6667 10.8335H16.0001C15.0001 10.8335 14.6667 11.5835 14.6667 12.5002Z"
        fill="#12B76A"
      />
    </svg>
  );
}
